import { Injectable } from '@angular/core';
import { StorageKeys, StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserStateService {
  userId: string | undefined;
  username: string | undefined;

  constructor(private storageService: StorageService) {
    this.loadFromStorage();
  }

  loadFromStorage(): void {
    const username = this.storageService.getItem(StorageKeys.USERNAME);
    if (username) {
      this.username = username;
    }

    const userId = this.storageService.getItem(StorageKeys.USER_ID);
    if (userId) {
      this.userId = userId;
    }
  }

  setUsername(username: string): void {
    this.username = username;
    this.storageService.setItem(StorageKeys.USERNAME, username);
  }

  setUserId(userId: string): void {
    this.userId = userId;
    this.storageService.setItem(StorageKeys.USER_ID, userId);
  }
}
